import { downloadBlob } from "../board/exportBoardPng";
import type { WbBoardScene } from "../board/wb-board-scene";
import { isPdfDocumentObject } from "../../editor/document/documentContext";

function presentationFilename(title: string): string {
  const safe = title
    .trim()
    .replace(/[^\w\u0400-\u04FF.-]+/gi, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);
  return `${safe || "presentation"}.pdf`;
}

/** Скачивает исходный PDF презентации (не PNG-страницы с доски). */
export async function downloadPresentationPdf(
  scene: InstanceType<typeof WbBoardScene>,
  objectId: string
): Promise<void> {
  const obj = scene.findObject(objectId);
  if (!obj || !isPdfDocumentObject(obj)) {
    throw new Error("Презентация не найдена");
  }

  const sourceAssetId =
    typeof (obj as { sourceAssetId?: unknown }).sourceAssetId === "string"
      ? (obj as { sourceAssetId: string }).sourceAssetId
      : "";
  if (!sourceAssetId) {
    throw new Error("Исходный файл недоступен");
  }

  const res = await fetch(scene.assetContentUrl(sourceAssetId), scene.fetchOpts());
  if (!res.ok) {
    throw new Error("Не удалось загрузить файл");
  }

  const blob = await res.blob();
  const title = typeof obj.title === "string" && obj.title.trim() ? obj.title : "presentation";
  downloadBlob(blob, presentationFilename(title));
}
